<mat-toolbar class="toolbar mat-app-background">
    <mat-grid-list cols="1" rowHeight="65px">
      <mat-grid-tile class="tileAlignmentStart">
        <img routerLink="/launchpad" src="../assets/img/allegion.svg" alt="allegion" width="35" />&nbsp;&nbsp;
        <h1>{{title}}</h1>
      </mat-grid-tile>
    </mat-grid-list>
  </mat-toolbar>